export const links = {
  github: 'https://github.com/magnifydev/magnify',
  programOfStudiesPDF:
    'https://linnmark12iaus.b-cdn.net/wp-content/uploads/2023/12/2025-2026-LMHS-Program-of-Studies-FINAL11-compressed-1.pdf',
};
